var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 514.25 517.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.13,500.17c-69.54-2.78-125.94-8.94-137.34-26.62.13-16,.24-30.91.37-46.91-5.82-8.7-11.82-20.83-11.77-31.22.13-26.19,12.16-53.92,12.43-78.08-4.84-13.56-4.6-9.22-2.27-23.95,1.9-11.95,3.51-22.63,5.09-34.14-11.33-49.54-28.13-101.91-52.15-157.62,5.61-13.39,18-22.81,35.59-30.52,3.9-1.71,7.78-3.22,11.92-4.78,13.86-5.24,23.08-7.36,37.29-10.81,10.68-2.59,20.6-5.38,32.69-8.35q4.59-17.28,9.17-34.56c13-8.77,33.62-12.25,59-12.36,25.35.11,45.93,3.59,59,12.36q4.57,17.28,9.17,34.56c12.09,3,22,5.76,32.69,8.35,14.21,3.45,23.43,5.57,37.29,10.81,4.14,1.56,8,3.07,11.92,4.78,17.62,7.71,30,17.13,35.59,30.52-24,55.71-40.82,108.08-52.15,157.62,1.58,11.51,3.19,22.19,5.09,34.14,2.33,14.73,2.57,10.39-2.27,23.95.27,24.16,12.3,51.89,12.43,78.08.05,10.39-5.95,22.52-11.77,31.22.13,16,.24,30.91.37,46.91-11.4,17.68-67.8,23.84-137.33,26.62Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.13,500.17c-69.54-2.78-125.94-8.94-137.34-26.62.13-16,.24-30.91.37-46.91,66.26,27.65,223.29,27.87,273.93,0,.13,16,.24,30.91.37,46.91-11.4,17.68-67.8,23.84-137.33,26.62Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.08,463.05c25.36-2.44,46.31,1.64,63.75,10.87L465.37,517c-24.3,1.13-43.53-2.81-58.26-11.25l8-42.74Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189,47.17q4.59-17.28,9.17-34.56a52.52,52.52,0,0,1,10.42-5.34c-8.2,5.16-7,11.38,1.24,17.88C223.57,36,242.21,51.8,256.94,64.53c5.17,4.47,9.86,8.57,13.69,11.94-10.31.43-18.24,1-26.81,0-25.61-3-44.92-13.32-54.84-29.3Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.47,47.17q-4.59-17.28-9.17-34.56a52.52,52.52,0,0,0-10.42-5.34c8.2,5.16,7,11.38-1.24,17.88C290.88,36,272.24,51.8,257.51,64.53,252.34,69,252.07,72.65,251.8,77a107.91,107.91,0,0,0,25.34-1.48c22.38-3.89,39.28-13.76,48.33-28.35Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.17,463.05c-25.36-2.44-46.31,1.64-63.75,10.87L48.88,517c24.3,1.13,43.53-2.81,58.26-11.25l-8-42.74Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view-front") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.64,259.25c-11.33-49.54-28.13-101.91-52.15-157.62-25.88,57-45.17,119.91-66.78,177.83C-1.11,295.07,4,299.3,2.28,314.05A279.59,279.59,0,0,0,1.15,370c.78,9.43,4.34,20.09,6.13,29.13a290.22,290.22,0,0,1,4.91,37.63c.1,2.07,4.48,2.19,5,4.07.77,2.55-3,7-1.95,9.5,5.34,12,14.53,15,20.13,23.61l63.75-10.87c-.63-11.21,2.21-24.94,1.23-35.68-.61-6.65-5.27-12.31-5.86-24.37-.07-1.22-.13-2.45-.18-3.68-.69-14.67.15-29.69-.4-44.55-.12-3.3-3.25-5.67-3.51-9-.23-2.84,3.62-5.66,3.71-8.61.08-2.44-4.32-4.13-4.29-6.64,0-3.21,5.1-1.77,5.4-3.76.41-2.75-4.53-4.15-4.66-6.57,1-1.78,4.63-1.88,5.44-3.79,7.16-16.84,21.4-40.63,27.59-57.19Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.13,500.17c-69.54-2.78-125.94-8.94-137.34-26.62.13-16,.24-30.91.37-46.91-5.82-8.7-11.82-20.83-11.77-31.22.13-26.19,12.16-53.92,12.43-78.08-4.84-13.56-4.6-9.22-2.27-23.95,1.9-11.95,3.51-22.63,5.09-34.14-11.33-49.54-28.13-101.91-52.15-157.62,5.61-13.39,18-22.81,35.59-30.52,3.9-1.71,7.78-3.22,11.92-4.78,13.86-5.24,23.08-7.36,37.29-10.81,10.68-2.59,20.6-5.38,32.69-8.35q4.59-17.28,9.17-34.56c13-8.77,33.62-12.25,59-12.36,25.35.11,45.93,3.59,59,12.36q4.57,17.28,9.17,34.56c12.09,3,22,5.76,32.69,8.35,14.21,3.45,23.43,5.57,37.29,10.81,4.14,1.56,8,3.07,11.92,4.78,17.62,7.71,30,17.13,35.59,30.52-24,55.71-40.82,108.08-52.15,157.62,1.58,11.51,3.19,22.19,5.09,34.14,2.33,14.73,2.57,10.39-2.27,23.95.27,24.16,12.3,51.89,12.43,78.08.05,10.39-5.95,22.52-11.77,31.22.13,16,.24,30.91.37,46.91-11.4,17.68-67.8,23.84-137.33,26.62Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "136.31 384.57 191.2 308.88 202.66 317.18 147.77 392.88 136.31 384.57 136.31 384.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.76 392.88 312.87 317.18 324.33 308.88 379.22 384.57 367.76 392.88 367.76 392.88",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.13,500.17c-69.54-2.78-125.94-8.94-137.34-26.62.13-16,.24-30.91.37-46.91-5.82-8.7-11.82-20.83-11.77-31.22.13-26.19,12.16-53.92,12.43-78.08-4.84-13.56-4.6-9.22-2.27-23.95,1.9-11.95,3.51-22.63,5.09-34.14-11.33-49.54-28.13-101.91-52.15-157.62,5.61-13.39,18-22.81,35.59-30.52,3.9-1.71,7.78-3.22,11.92-4.78,13.86-5.24,23.08-7.36,37.29-10.81,10.68-2.59,20.6-5.38,32.69-8.35q4.59-17.28,9.17-34.56c13-8.77,33.62-12.25,59-12.36,25.35.11,45.93,3.59,59,12.36q4.57,17.28,9.17,34.56c12.09,3,22,5.76,32.69,8.35,14.21,3.45,23.43,5.57,37.29,10.81,4.14,1.56,8,3.07,11.92,4.78,17.62,7.71,30,17.13,35.59,30.52-24,55.71-40.82,108.08-52.15,157.62,1.58,11.51,3.19,22.19,5.09,34.14,2.33,14.73,2.57,10.39-2.27,23.95.27,24.16,12.3,51.89,12.43,78.08.05,10.39-5.95,22.52-11.77,31.22.13,16,.24,30.91.37,46.91-11.4,17.68-67.8,23.84-137.33,26.62Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.13,500.17c-69.54-2.78-125.94-8.94-137.34-26.62.13-16,.24-30.91.37-46.91,66.26,27.65,223.29,27.87,273.93,0,.13,16,.24,30.91.37,46.91-11.4,17.68-67.8,23.84-137.33,26.62Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,438.86l-.07,8.95c9.16,6.22,22.39,10.86,38.84,14.25,17.51,3.61,38.75,5.84,62.68,7.08l.36-7.06c-23.6-1.22-44.5-3.4-61.62-6.94-16.8-3.46-29.88-8.19-38.18-14.55l-2-1.73ZM119.86,453l-.07,9c9.17,6.26,22.43,10.92,39,14.33,17.51,3.61,38.75,5.84,62.68,7.08l.36-7.06c-23.6-1.22-44.5-3.41-61.62-6.94-16.8-3.47-29.88-8.2-38.18-14.55L119.86,453Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.19,438.86l.07,8.95c-9.16,6.22-22.39,10.86-38.84,14.25-17.51,3.61-38.76,5.84-62.68,7.08l-.36-7.06c23.6-1.22,44.5-3.4,61.62-6.94,16.8-3.46,29.88-8.19,38.18-14.55l2-1.73ZM394.3,453l.07,9c-9.17,6.26-22.43,10.92-38.95,14.33-17.51,3.61-38.76,5.84-62.68,7.08l-.36-7.06c23.6-1.22,44.5-3.41,61.62-6.94,16.8-3.47,29.88-8.2,38.18-14.55L394.3,453Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.13,500.17c-69.54-2.78-125.94-8.94-137.34-26.62.13-16,.24-30.91.37-46.91,66.26,27.65,223.29,27.87,273.93,0,.13,16,.24,30.91.37,46.91-11.4,17.68-67.8,23.84-137.33,26.62Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.61,259.25c11.33-49.54,28.13-101.91,52.15-157.62,25.88,57,45.17,119.91,66.78,177.83,5.82,15.61.69,19.84,2.43,34.59A279.59,279.59,0,0,1,513.1,370c-.78,9.43-4.34,20.09-6.13,29.13a290.22,290.22,0,0,0-4.91,37.63c-.11,2.07-4.48,2.19-5.05,4.07-.78,2.55,3,7,1.94,9.5-5.33,12-14.52,15-20.12,23.61l-63.75-10.87c.63-11.21-2.21-24.94-1.23-35.68.61-6.65,5.27-12.31,5.86-24.37.07-1.22.13-2.45.18-3.68.69-14.67-.16-29.69.4-44.55.12-3.3,3.25-5.67,3.51-9,.23-2.84-3.62-5.66-3.71-8.61-.08-2.44,4.32-4.13,4.29-6.64-.05-3.21-5.1-1.77-5.4-3.76-.41-2.75,4.53-4.15,4.66-6.57-1.05-1.78-4.63-1.88-5.44-3.79-7.16-16.84-21.4-40.63-27.59-57.19Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.08,463.05c25.36-2.44,46.31,1.64,63.75,10.87L465.37,517c-24.3,1.13-43.53-2.81-58.26-11.25l8-42.74Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.91,496.09l-2.18,7-.7-.46a83,83,0,0,0-26.81-9.93,134.93,134.93,0,0,0-31.49-2l-.81.07,1.34-7.17a141.29,141.29,0,0,1,32.29,2.16,90.25,90.25,0,0,1,28.36,10.36Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.24,485.42l-2.18,7-.76-.49A82.14,82.14,0,0,0,445,481.41a134,134,0,0,0-32.19-2.14l-.82.14,1.35-7.23a139.88,139.88,0,0,1,33,2.31,89.42,89.42,0,0,1,28.82,10.93Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.08,463.05c25.36-2.44,46.31,1.64,63.75,10.87L465.37,517c-24.3,1.13-43.53-2.81-58.26-11.25l8-42.74Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,47.17q4.59-17.28,9.17-34.56a52.52,52.52,0,0,1,10.42-5.34c-8.2,5.16-7,11.38,1.24,17.88C223.57,36,242.21,51.8,256.94,64.53c5.17,4.47,9.86,8.57,13.69,11.94-10.31.43-18.24,1-26.81,0-25.61-3-44.92-13.32-54.84-29.3Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190,43.52l1.57-5.92a158.47,158.47,0,0,0,13.83,12.19c8.37,6.86,17.44,14.3,23.42,22.59l.41.85.16.6c-2.83-.72-5.56-1.55-8.17-2.48-5.42-6.18-12.53-12-19.19-17.47-4.37-3.59-8.56-7-12-10.36Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.57,29.87l2.6-9.8L197.79,24c3.86,6.52,12.88,13.92,22.7,22,10.7,8.77,22.3,18.28,29.95,28.89l.51,1.09.31,1.14c-2.69-.11-5.35-.33-8.15-.67-7.13-9-17.4-17.4-26.93-25.22-9.18-7.52-17.7-14.51-22.61-21.31Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189,47.17q4.59-17.28,9.17-34.56a52.52,52.52,0,0,1,10.42-5.34c-8.2,5.16-7,11.38,1.24,17.88C223.57,36,242.21,51.8,256.94,64.53c5.17,4.47,9.86,8.57,13.69,11.94-10.31.43-18.24,1-26.81,0-25.61-3-44.92-13.32-54.84-29.3Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.8,
    y1: 77.09,
    x2: 251.8,
    y2: 499.83,
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "1.4173200130462646px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.47,47.17q-4.59-17.28-9.17-34.56a52.52,52.52,0,0,0-10.42-5.34c8.2,5.16,7,11.38-1.24,17.88C290.88,36,272.24,51.8,257.51,64.53,252.34,69,252.07,72.65,251.8,77a107.91,107.91,0,0,0,25.34-1.48c22.38-3.89,39.28-13.76,48.33-28.35Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-5)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.5,43.52l-1.57-5.92A158.47,158.47,0,0,1,309.1,49.79c-8.36,6.86-17.44,14.3-23.42,22.59l-.4.85-.16.6q4.25-1.08,8.16-2.48c5.42-6.18,12.54-12,19.19-17.47,4.38-3.59,8.56-7,12-10.36Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.88,29.87l-2.6-9.8L316.66,24C312.8,30.5,303.78,37.9,294,46c-10.7,8.77-22.31,18.28-30,28.89l-.52,1.09-.31,1.14c2.7-.11,5.36-.33,8.15-.67,7.14-9,17.4-17.4,26.93-25.22,9.18-7.52,17.7-14.51,22.61-21.31Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.47,47.17q-4.59-17.28-9.17-34.56a52.52,52.52,0,0,0-10.42-5.34c8.2,5.16,7,11.38-1.24,17.88C290.88,36,272.24,51.8,257.51,64.53,252.34,69,252.07,72.65,251.8,77a107.91,107.91,0,0,0,25.34-1.48c22.38-3.89,39.28-13.76,48.33-28.35Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,86.78a6.57,6.57,0,1,1-6.57,6.57,6.57,6.57,0,0,1,6.57-6.57Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,171.32a6.57,6.57,0,1,1-6.57,6.57,6.57,6.57,0,0,1,6.57-6.57Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,255.86a6.57,6.57,0,1,1-6.57,6.56,6.56,6.56,0,0,1,6.57-6.56Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,340.4a6.57,6.57,0,1,1-6.57,6.56,6.56,6.56,0,0,1,6.57-6.56Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,424.93a6.57,6.57,0,1,1-6.57,6.57,6.57,6.57,0,0,1,6.57-6.57Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,455.85a6.57,6.57,0,1,1-6.57,6.57,6.57,6.57,0,0,1,6.57-6.57Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,479.56a6.57,6.57,0,1,1-6.57,6.57,6.57,6.57,0,0,1,6.57-6.57Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17,463.05c-25.36-2.44-46.31,1.64-63.75,10.87L48.88,517c24.3,1.13,43.53-2.81,58.26-11.25l-8-42.74Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-6)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.34,496.09l2.18,7,.7-.46A83,83,0,0,1,72,492.67a134.93,134.93,0,0,1,31.49-2l.81.07L103,483.57a141.29,141.29,0,0,0-32.29,2.16,90.25,90.25,0,0,0-28.36,10.36Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,485.42l2.18,7,.76-.49a82.14,82.14,0,0,1,27.26-10.49,134,134,0,0,1,32.19-2.14l.82.14-1.35-7.23a139.88,139.88,0,0,0-33,2.31A89.42,89.42,0,0,0,39,485.42Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.17,463.05c-25.36-2.44-46.31,1.64-63.75,10.87L48.88,517c24.3,1.13,43.53-2.81,58.26-11.25l-8-42.74Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewFront);
export default __webpack_public_path__ + "static/media/view-front.21769fd698c8040821eb9a11373ad6b8.svg";
export { ForwardRef as ReactComponent };